module.exports = __webpack_public_path__ + "2d2e183c61919e2db36b5d9fa879bea6.png";